import React from "react";

export default function Footer() {
  return (
    <>
      <footer className="relative bg-lsfm-primary-50 pt-8 pb-6">
        <div
          className="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20"
          style={{ transform: "translateZ(0)" }}
        >
          <svg
            className="absolute bottom-0 overflow-hidden"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            version="1.1"
            viewBox="0 0 2560 100"
            x="0"
            y="0"
          >
            <polygon
              className="text-warmGray-300 fill-lsfm-light"
              points="2560 0 2560 120 0 100"
            ></polygon>
          </svg>
        </div>
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap text-center lg:text-left">
            <div className="w-full lg:w-6/12 px-4">
              <h4 className="text-3xl font-semibold text-warmGray-800">Nepalaid garām jaunākās ziņas no LSFM</h4>
              <h5 className="text-lg mt-0 mb-2 text-warmGray-600">
                Seko mums sociālajos tīklos
              </h5>
              <ul className="flex flex-row list-none mx-auto items-center justify-center lg:justify-start lg:mx-0">
                <li className="flex items-center">
                <a
                  className="lg:text-warmGray lg:hover:text-warmGray-800 text-warmGray-700 px-3 pb-4 lg:py-2 flex items-center text-xs uppercase font-bold"
                  href="https://instagram.com/latviansfm"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="text-warmGray-800 fab fa-instagram text-lg leading-lg " />
                </a>
              </li>
              <li className="flex items-center">
                <a
                  className="lg:text-warmGray-800 lg:hover:text-warmGray-800 text-warmGray-700 px-3 pb-4 lg:py-2 flex items-center text-xs uppercase font-bold"
                  href="https://www.facebook.com/profile.php?id=61555953753126#"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="text-warmGray-800  fab fa-facebook text-lg leading-lg " />
                </a>
              </li>

              
              </ul>
              
            </div>
            <div className="w-full lg:w-6/12 px-4">
              <div className="flex flex-wrap items-top mb-6">
                <div className="w-full lg:w-4/12 px-4 ml-auto">
                  <span className="block uppercase text-warmGray-600 text-sm font-semibold mb-2">
                    Valodas
                  </span>
                  <ul className="list-unstyled">
                    <li>
                      <a
                        className="text-warmGray-600 hover:text-warmGray-800 font-semibold block pb-2 text-sm"
                        href="/"
                      >
                        Latviski
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-warmGray-600 hover:text-warmGray-800 font-semibold block pb-2 text-sm"
                        href="/"
                      >
                        English [coming soon]
                      </a>
                    </li>
                    
                  </ul>
                </div>
                
              </div>
            </div>
          </div>
          <hr className="my-6 border-warmGray-300" />
          <div className="flex flex-wrap items-center md:justify-between justify-center">
            <div className="w-full md:w-4/12 px-4 mx-auto text-center">
              <div className="text-sm text-warmGray-500 font-semibold py-1" style={{ marginBottom: '80px' }}>
                Copyright © {new Date().getFullYear()} LSFM <br/>
                Developed by {" "}
                <a
                  href="https://www.upwork.com/freelancers/~01286775660ce6ce67?mp_source=share"
                  target="_blank"
                  rel="noreferrer"
                  className="text-warmGray-500 hover:text-warmGray-800"
                >
                 Oleg from Luna and Ivy
                </a>
                .<br/>
                Design by Notus React by{" "}
                <a
                  href="https://www.creative-tim.com?ref=nr-footer"
                  target="_blank"
                  rel="noreferrer"
                  className="text-warmGray-500 hover:text-warmGray-800"
                >
                  Creative Tim
                </a>
                .
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
